export default __webpack_public_path__ + "static/media/F0006.f5f1940e.png";